export const downloadFile = (content: Blob, fileName: string) => {
  const link = document.createElement('a')

  link.download = fileName
  link.href = URL.createObjectURL(content)
  link.click()

  URL.revokeObjectURL(link.href)
}
